import { render, staticRenderFns } from "./VcitaEmojiPicker.vue?vue&type=template&id=d4921b8c&scoped=true"
import script from "./VcitaEmojiPicker.vue?vue&type=script&lang=js"
export * from "./VcitaEmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./VcitaEmojiPicker.vue?vue&type=style&index=0&id=d4921b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4921b8c",
  null
  
)

export default component.exports